import { useCallback } from "react"
import { DashBoardCondition } from "features/dashBoard/types"
import { TimeOperations, useHeatMapGraphOption } from "./options"

type useHeatMapGraphEventsProps<T> = {
	graphOption: ReturnType<typeof useHeatMapGraphOption<T>>
	onChangeCondition: (
    axisKey?: string,
    changed?: DashBoardCondition,
    toggle?: boolean
  ) => void
}
export const useHeatMapGraphEvents = <T,>({
	graphOption: {
		timeDef, by
	},
	onChangeCondition
}: useHeatMapGraphEventsProps<T>) => {
	const onClickGraph = useCallback(
		(params?: {
			event?: { event?: { ctrlKey?: boolean } }
			data: number[]
		}) => {
			const data = params?.data
			if (!data || data.length < 3) return

			const operation = TimeOperations[by]
			if (!operation) return
			if (!timeDef?.key) return

			const label = operation.toolTipLabel
			const condition = operation.condition(data)

			onChangeCondition(
				timeDef.key,
				{
					code: [condition],
					label: `${label.y[data[1]]} ${label.x[data[0]]}`,
					time: true
				},
				params?.event?.event?.ctrlKey ? true : false
			)
		},
		[timeDef, by, onChangeCondition]
	)
	return {
		click: onClickGraph
	}
}